// src/components/Map/MapLegend.tsx
import React from 'react';
import { useMap } from '../../hooks/useMap';
import { useProcessing } from '../../context/ProcessingContext';

export const MapLegend: React.FC = () => {
 const { state } = useProcessing();
 const { settings } = useMap();

 if (!state.interpolatedData?.ml) return null;

 const { min, max } = state.interpolatedData.ml.stats;
 const interval = (max - min) / 10;
 const levels = Array.from({length: 11}, (_, i) => min + (i * interval));

 const getColor = (value: number): string => {
   const normalized = (value - min) / (max - min);
   const hue = 240 - (normalized * 240); // Blue to Red
   return `hsl(${hue}, 70%, 50%)`;
 };

 return (
   <div className="map-legend">
     <h4>Elevation Values</h4>
     <div className="legend-items">
       {levels.map((level, i) => (
         <div key={i} className="legend-item">
           <span 
             className="color-box" 
             style={{ 
               backgroundColor: getColor(level),
               opacity: settings.contourOpacity 
             }} 
           />
           <span className="legend-label">{level.toFixed(1)}</span>
         </div>
       ))}
     </div>
   </div>
 );
};